/**
 * The shared typed page module (`./trackers-ui/page`): the typed page view,
 * the type page's table, Links and the tree's type resolver. Loaded once,
 * when Pages opens, so the eager tracker graph does not carry it.
 */
import { useEffect, useState } from 'react';
import { loadTrackerPage } from '@nimbalyst/collab-bundle/trackers-ui';

export type PageModule = Awaited<ReturnType<typeof loadTrackerPage>>;
let pageModule: Promise<PageModule> | null = null;

export function usePageModule(): PageModule | null {
  const [loaded, setLoaded] = useState<PageModule | null>(null);
  useEffect(() => {
    let live = true;
    void (pageModule ??= loadTrackerPage()).then((module) => { if (live) setLoaded(module); });
    return () => { live = false; };
  }, []);
  return loaded;
}
